import React, { useEffect, useState } from 'react'
import './MyCareersPage.scss';
import { LevelContainer } from '../../components/LevelContainer/LevelContainer';
import { getCareersByUser } from '../../data/api';
import { ButtonCareer } from './ButtonCareer';
import { saveCareer } from './../../data/api';
import { Bounce, toast } from 'react-toastify';

import { useNavigate } from 'react-router-dom';
import { LinearProgress, Skeleton } from '@mui/material';
import { CalendarBanner } from '../../components/CalendarBanner/CalendarBanner';

export const MyCareersPage = ({ toggleHowWorks, toggleAddCareer, toggleDeleteCareer }) => {

  const [data, setData] = useState(null);
  const [progress, setProgress] = useState(0);
  const [careers, setCareers] = useState(null);
  const [dataByLevels, setDataByLevels] = useState(null);
  const [selectedCareer, setSelectedCareer] = useState(null);
  const [exceptionMode, setExceptionMode] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const userId = localStorage.getItem('userId');
      if (!userId) {
        navigate('/');
        return;
      }

      const resp = await getCareersByUser(userId)
      if (resp.careers.length === 0) {
        setCareers([])
        return
      }

      setCareers(resp.careers)
    }

    fetchData()
  }, []);

  useEffect(() => {
    if (!data) return;

    updateProgress(data);

    const newData = reorderData(data, exceptionMode);
    if (JSON.stringify(newData) !== JSON.stringify(data)) {
      setData(newData);
      setDataByLevels(groupByLevels(newData));
    }
  }, [data, exceptionMode]);

  const updateProgress = (subjectsData) => {
    if (!subjectsData) return;

    const totalSubjects = Object.keys(subjectsData).length;
    const approvedSubjects = Object.values(subjectsData).filter(subject => subject.estado === 'approved').length;

    setProgress((approvedSubjects / totalSubjects) * 100)
  }

  const groupByLevels = (content) => {
    const levels = {};

    Object.keys(content).forEach(key => {
      const materia = content[key];
      const nivel = materia.nivel;

      if (!levels[nivel]) {
        levels[nivel] = {};
      }

      levels[nivel][key] = materia;
    });

    return levels;
  }

  const reorderData = (subjectsData, ignoreCorrelatives = false) => {
    if (!subjectsData) {
      return {};
    }

    const newData = JSON.parse(JSON.stringify(subjectsData));

    if (ignoreCorrelatives) {
      Object.keys(newData).forEach(key => {
        if (newData[key].estado === 'locked') {
          newData[key].estado = 'not-regularized';
        }
      });

      return newData;
    }

    Object.keys(newData).forEach(key => {
      const materia = newData[key];
      let flag = true;

      if (materia.estado !== 'locked' && materia.estado !== 'not-regularized') {
        return;
      }

      if (materia.cursadasParaCursar.length !== 0) {
        materia.cursadasParaCursar.forEach(i => {
          if (newData[i].estado !== 'regularized' && newData[i].estado !== 'approved') {
            flag = false;
          }
        });
      }

      if (materia.aprobadasParaCursar.length !== 0) {
        materia.aprobadasParaCursar.forEach(i => {
          if (newData[i].estado !== 'approved') {
            flag = false;
          }
        });
      }

      if (flag) {
        newData[key].estado = 'not-regularized';
      } else {
        newData[key].estado = 'locked';
      }
    });

    return newData;
  }

  const updateSubject = (clave, estado) => {
    const newData = {
      ...data,
      [clave]: {
        ...data[clave],
        estado: estado,
      },
    };

    setData(newData);
    updateProgress(newData);
  }

  const saveChanges = async () => {
    const career = {
      _id: selectedCareer,
      name: careers.find(car => car._id === selectedCareer).name,
      content: data,
      exceptionMode: exceptionMode
    }

    const resp = await saveCareer(career)
    if (resp.status === 'success') {
      setCareers(resp.careers)
      toast.success('Cambios guardados', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      });
    } else {
      toast.error(resp.error, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      });
    }
  }

  const handleSelectCareer = (careerId) => {
    const career = careers.find(car => car._id === careerId);
    showCareer(career)
    setSelectedCareer(careerId);
    setExceptionMode(Boolean(career.exceptionMode));
  };

  const showCareer = (career) => {
    const content = reorderData(career.content, Boolean(career.exceptionMode))

    setData(content)
    setDataByLevels(groupByLevels(content));
  }

  const handleExceptionMode = (event) => {
    const enabled = event.target.checked;
    const newData = reorderData(data, enabled);

    setExceptionMode(enabled);
    setData(newData);
    setDataByLevels(groupByLevels(newData));
  }

  const deleteCareer = () => {
    const career = {
      _id: selectedCareer,
      name: careers.find(car => car._id === selectedCareer).name,
      content: data,
      exceptionMode: exceptionMode
    }

    toggleDeleteCareer(career)
  }

  return (
    <div className='careers-page-container'>
      <CalendarBanner />
      <div className='careers-page-top'>
        <button className='btn-add-career' onClick={toggleAddCareer}>+ Agregar carrera</button>
        <button className='btn-how-works' onClick={toggleHowWorks}>¿Cómo funciona?</button>
      </div>
      <div className='careers-container'>
        {careers ? (careers.map((career) => (
          <ButtonCareer
            key={career._id}
            name={career.name}
            onClick={() => handleSelectCareer(career._id)}
            isSelected={selectedCareer === career._id}
          />
        ))) : (
          Array.from({ length: 6 }).map((_, index) => <Skeleton key={index} style={{ margin: '10px', borderRadius: '5px' }} variant="rounded" width={Math.floor(Math.random() * (200 - 80)) + 40} height={30} />)
        )}
      </div>
      {careers && careers.length === 0 && <p className='no-careers-text'>No tienes ninguna carrera creada todavía</p>}
      {selectedCareer && (
        <div className="btns-career">
          <button className='btn-save-changes' onClick={saveChanges}>Guardar cambios</button>
          <button className='btn-delete-career' onClick={deleteCareer}>Eliminar carrera</button>
          <label className='exception-mode-switch'>
            <input type='checkbox' checked={exceptionMode} onChange={handleExceptionMode} />
            <span className='exception-mode-slider'></span>
            <span className='exception-mode-label'>Excepción de correlativas</span>
          </label>
          <div className='progress-div'>
            <p className='progress-label'>{progress.toFixed(0)}%</p>
            <div className='progress'>
              <LinearProgress variant="determinate" value={progress}
                sx={{
                  margin: '20px',
                  height: 12,
                  borderRadius: 10,
                  backgroundColor: '#0868883a',
                  '& .MuiLinearProgress-bar': {
                    borderRadius: 10,
                    backgroundColor: '#086788',
                  },
                }}
              />
            </div>
          </div>
        </div>
      )}
      <div className="levels-container">
        {dataByLevels !== null && Object.keys(dataByLevels).map(key => {
          return (<LevelContainer key={key} updateSubject={updateSubject} data={data} level={key} subjects={dataByLevels[key]} />)
        })}
        {selectedCareer == null && careers && careers.length !== 0 && <p>No seleccionaste ninguna carrera</p>}
      </div>
    </div>
  )
}
